/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../../../../client-dashboard/src/app/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.PartnerAccountFundTransferAndWithdrawResponse,
  partnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => Promise<vp.PartnerAccountFundTransferAndWithdrawResponse>,
  initiatePartnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostPartnerAccountFundTransferAndWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldPartnerAccountFundTransferAndWithdraw, setShouldPartnerAccountFundTransferAndWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PartnerAccountTransferRequest>({
    TransferTypeID: '',
    DebitorAccountID: '',
    RecipientAccountID: '',
    Amount: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountFundTransferAndWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    FundingTransactionID: '',
    AccountTransferID: '',
    WithdrawTransactionID: '',
  });

  useEffect(() => {
    if (!shouldPartnerAccountFundTransferAndWithdraw) return () => {};

    const PostPartnerAccountFundTransferAndWithdraw = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postPartnerAccountFundTransferAndWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldPartnerAccountFundTransferAndWithdraw) void PostPartnerAccountFundTransferAndWithdraw();
    setShouldPartnerAccountFundTransferAndWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldPartnerAccountFundTransferAndWithdraw]);

  return [
    response,
    (_params: vp.PartnerAccountTransferRequest) => api.postPartnerAccountFundTransferAndWithdraw(_params, source),
    (_params: vp.PartnerAccountTransferRequest) => {
      setParams(_params);
      setShouldPartnerAccountFundTransferAndWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FundingTransactionID: '',
        AccountTransferID: '',
        WithdrawTransactionID: '',
      });
      setShouldPartnerAccountFundTransferAndWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostPartnerAccountFundTransferAndWithdraw);
